@if (incomeTaxEntity$ | async) {
  <form [formGroup]="formGroup">
    @if (leningen.length > 0) {
      <div formArrayName="leningen">
        @for (item of leningen.controls; track item; let i = $index) {
          <div [formGroupName]="i">
            <div class="row col-auto" style="--bs-gutter-x: 0.5rem;">
              <snelstart-ui-text-form-control [label]="i === 0 ? 'Omschrijving' : ''"
                                              class="custom-input-225"
                                              formControlName="omschrijving"
                                              id="omschrijving"
              >
              </snelstart-ui-text-form-control>
              <snelstart-ui-text-form-control [label]="i === 0 ? 'Rekeningnummer' : ''"
                                              class="custom-input-150"
                                              formControlName="rekeningNummer"
                                              id="rekeningNummer"
              >
              </snelstart-ui-text-form-control>
              @if(isDefAangifte) {
                <snelstart-ui-number-form-control [decimals]="0"
                                                  [label]="i === 0 ? 'Hoofdsom 1-1' : ''"
                                                  align="right"
                                                  class="custom-input-150"
                                                  formControlName="hoofdsom0101"
                                                  id="hoofdsom0101"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
                <snelstart-ui-number-form-control [decimals]="0"
                                                  [label]="i === 0 ? 'Hoofdsom 31-12' : ''"
                                                  align="right"
                                                  class="custom-input-150"
                                                  formControlName="hoofdsom3112"
                                                  id="hoofdsom3112"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
              }
              <snelstart-ui-number-form-control [decimals]="0"
                                                [label]="i === 0 ? 'Betaalde rente' : ''"
                                                align="right"
                                                class="custom-input-150"
                                                formControlName="rente"
                                                id="rente"
                                                prefix="€"
              >
              </snelstart-ui-number-form-control>
              @if(isDefAangifte) {
                <snelstart-ui-select-form-control [label]="i === 0 ? 'Geldverstrekker' : ''"
                                                  [options]="soortLeningGeldVerstrekker"
                                                  [required]=true
                                                  class="custom-input-175"
                                                  formControlName="geldVerstrekker"
                >
                </snelstart-ui-select-form-control>
              }
              <snelstart-ui-number-form-control [label]="i === 0 ? '% box 1' : ''"
                                                [maxValue]="100"
                                                [showAllDecimals]="true"
                                                align="right"
                                                class="custom-input-100"
                                                formControlName="percentageBox1"
                                                id="percentageBox1"
                                                postfix="%"
              >
              </snelstart-ui-number-form-control>
              <snelstart-ui-button (click)="deleteRij(i)"
                                   [class]="i === 0 ? 'firstrowbutton col-auto' : 'col-auto'"
                                   class="delete"
                                   icon="trash"
                                   id="buttonDelete"
                                   size="medium"
                                   type="secondary"
              >
              </snelstart-ui-button>
            </div>
          </div>
        }
      </div>
    }
    <snelstart-ui-button (click)="addRij()" class="snelstart-ui-button" icon="plus"
                         type="link">Lening toevoegen
    </snelstart-ui-button>
  </form>
}

@for (item of leningen.controls; track item; let i = $index) {
  @if (item.value.geldVerstrekker === LeningGeldVerstrekker.NIET_ADMINISTRATIEPLICHTIGE) {
    <div class="mb-2 mt-3">
      @if (i === 0) {
        <snelstart-ui-alert type="info">
          Er zijn leningen aangegaan bij niet-administratieplichtige geldverstrekkers. Deze leningen moeten hieronder
          van nadere informatie worden voorzien.
        </snelstart-ui-alert>
      }
      <snelstart-ui-button
        (click)="this.showDialog(i)"
        icon="pencil"
        type="secondary">
        @if (item.value.omschrijving || item.value.rekeningNummer) {
          Specificatie lening {{ item.value.omschrijving || item.value.rekeningNummer }}
        } @else {
          Specificatie lening {{ i + 1 }}
        }
      </snelstart-ui-button>
    </div>
  }
}

@if (hasPercentageBox1LessThan100()) {
  <snelstart-ui-alert type="info">
    <b>Let op!</b> <br>
    Er is ingevuld dat een van de leningen gedeeltelijk in box 1 valt. Het deel van de hoofdsom per 1 januari dat
    niet in box 1 zit, is automatisch verwerkt als schuld in het vermogen (box 3). Is dat niet juist? Pas de
    gegevens dan aan bij de schulden in box 3. <br/>
    Zorg er dan wel voor dat je hier voor de hoofdsommen (1 januari en 31 december) en de betaalde rente 'gewoon'
    100% van de bedragen ingevuld hebt. Voor de berekeningen wordt de betaalde rente dan automatisch naar rato
    meegenomen als rente eigen woning.
  </snelstart-ui-alert>
}

<snelstart-ui-dialog-definition [(visible)]="dialogVisible" id="leningBijzonderheden" size="lg"
                                title="Gegevens lening en -verstrekker">
  <snelstart-ui-dialog-body>
    <form (change)="saveForm()" [formGroup]="formGroup">
      @if (leningen.length > 0) {
        <div formArrayName="leningen">
          @for (item of leningen.controls; track item; let i = $index) {
            <div [formGroupName]="i">
              @if (item.get('geldVerstrekker')?.getRawValue() === LeningGeldVerstrekker.NIET_ADMINISTRATIEPLICHTIGE) {
                <div class="row">
                  <div class="col-7">
                    <p>Aanvangsdatum van de lening</p>
                  </div>
                  <div class="col-2">
                    <snelstart-ui-date-form-control class="custom-input-250"
                                                    formControlName="aanvangsDatum"
                                                    id="aanvangsDatum"
                                                    label=""
                                                    placeholder="dd-mm-jjjj"
                    >
                    </snelstart-ui-date-form-control>
                  </div>
                  <div class="col-3"></div>
                </div>
                <div class="row">
                  <div class="col-7">
                    <p>Einddatum van de lening</p>
                  </div>
                  <div class="col-2">
                    <snelstart-ui-date-form-control class="custom-input-250"
                                                    formControlName="eindDatum"
                                                    id="eindDatum"
                                                    label=""
                                                    placeholder="dd-mm-jjjj"
                    >
                    </snelstart-ui-date-form-control>
                  </div>
                  <div class="col-3"></div>
                </div>
                <div class="row">
                  <div class="col-7">
                    <p>Oorspronkelijke hoofdsom van de lening</p>
                  </div>
                  <div class="col-2">
                    <snelstart-ui-number-form-control [decimals]="0"
                                                      align="right"
                                                      class="custom-input-250"
                                                      formControlName="oorspronkelijkeHoofdsom"
                                                      id="oorspronkelijkeHoofdsom"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                  </div>
                  <div class="col-3"></div>
                </div>
                <div class="row">
                  <div class="col-7">
                    <p>Aflossingsmethode</p>
                  </div>
                  <div class="col-2">
                    <snelstart-ui-select-form-control [options]="soortLeningAflossingsMethode"
                                                      class="custom-input-250"
                                                      formControlName="aflossingsMethode"
                    >
                    </snelstart-ui-select-form-control>
                  </div>
                  <div class="col-3"></div>
                </div>
                <div class="row">
                  <div class="col-7">
                    <p>Rentepercentage in decimalen</p>
                  </div>
                  <div class="col-2">
                    <snelstart-ui-number-form-control align="right"
                                                      class="custom-input-250"
                                                      formControlName="rentePercentageDecimalen"
                                                      id="rentePercentageDecimalen"
                                                      postfix="%"
                    >
                    </snelstart-ui-number-form-control>
                  </div>
                  <div class="col-3"></div>
                </div>

                <div class="pt-3 pb-3">
                  <b>Gegevens van de leningverstrekker</b>
                </div>

                <div formGroupName="naamLeninggever">
                  <div class="row">
                    <div class="col-7">
                      <p>Naam van de leningverstrekker</p>
                    </div>
                    <div class="col-2">
                      <snelstart-ui-text-form-control class="custom-input-250"
                                                      formControlName="achternaam"
                                                      id="achternaam"
                      >
                      </snelstart-ui-text-form-control>
                    </div>
                    <div class="col-3"></div>
                  </div>
                  <div class="row">
                    <div class="col-7">
                      <p>Bsn of RSIN van de leningverstrekker</p>
                    </div>
                    <div class="col-2">
                      <snelstart-ui-bsn-form-control class="custom-input-250"
                                                     formControlName="bsn"
                                                     id="bsn"
                                                     label=""
                      >
                      </snelstart-ui-bsn-form-control>
                    </div>
                    <div class="col-3"></div>
                  </div>
                  <div class="row">
                    <div class="col-7">
                      <p>Geboortedatum (optioneel)</p>
                    </div>
                    <div class="col-2">
                      <snelstart-ui-date-form-control class="custom-input-250"
                                                      formControlName="geboortedatum"
                                                      id="geboortedatum"
                                                      label=""
                                                      placeholder="dd-mm-jjjj"
                      >
                      </snelstart-ui-date-form-control>
                    </div>
                    <div class="col-3"></div>
                  </div>
                </div>

                <div class="pt-3 pb-3">
                  <b>Adres van de leningverstrekker</b>
                </div>

                <div formGroupName="adresLeninggever">
                  <div class="row">
                    <div class="col-7">
                      <p>Postcode, huisummer en toevoeging</p>
                    </div>
                    <div class="col-auto">
                      <div class="row" style="--bs-gutter-x: 0.5rem;">
                        <div class="col-auto">
                          <snelstart-ui-text-form-control class="custom-input-100"
                                                          formControlName="postcode"
                                                          id="postcode"
                                                          placeholder="Postcode"
                          >
                          </snelstart-ui-text-form-control>
                        </div>
                        <div class="col-auto">
                          <snelstart-ui-number-form-control [showAllDecimals]="false"
                                                            class="custom-input-75"
                                                            formControlName="huisNummer"
                                                            id="huisNummer"
                                                            placeholder="Nr."
                          >
                          </snelstart-ui-number-form-control>
                        </div>
                        <div class="col-auto">
                          <snelstart-ui-text-form-control class="custom-input-60"
                                                          formControlName="huisNummerToevoeging"
                                                          id="huisNummerToevoeging"
                                                          placeholder="Tv."
                          >
                          </snelstart-ui-text-form-control>
                        </div>
                      </div>
                    </div>
                    <div class="col-3"></div>
                  </div>
                  <div class="row">
                    <div class="col-7">
                      <p>Woon- of vestigingsplaats</p>
                    </div>
                    <div class="col-2">
                      <snelstart-ui-text-form-control class="custom-input-250"
                                                      formControlName="woonplaats"
                                                      id="woonplaats"
                                                      label=""
                      >
                      </snelstart-ui-text-form-control>
                    </div>
                    <div class="col-3"></div>
                  </div>
                  <div class="row">
                    <div class="col-7">
                      <p>Woon- of vestigingsland</p>
                    </div>
                    <div class="col-2">
                      <snelstart-ui-select-form-control [options]="optionsLandcodes"
                                                        class="custom-input-250"
                                                        formControlName="landCode"
                      >
                      </snelstart-ui-select-form-control>
                      <div class="col-3"></div>
                    </div>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      }
    </form>
  </snelstart-ui-dialog-body>
  <snelstart-ui-dialog-buttons class="d-flex">
    <snelstart-ui-button btn-x class="me-1" id="cancel" type="secondary">Annuleren</snelstart-ui-button>
    <snelstart-ui-button [disabled]="!isCurrentLeningValid" icon="check" id="save" type="primary">Opslaan
    </snelstart-ui-button>
  </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>
